<div class="email-compose-cell-container" [class.edit-mode]="isEditMode" [class.view-mode]="!isEditMode">
  <button
    mat-raised-button
    [color]="buttonColor"
    [disabled]="isDisabled"
    [matTooltip]="recipientsTooltip"
    (click)="onCompose()"
    class="email-compose-button">
    <mat-icon class="email-compose-icon">email</mat-icon>
    <span class="email-compose-label">{{ buttonText }}</span>
    <span class="email-compose-count" *ngIf="showCount && recipientCount > 0">({{ recipientCount }})</span>
  </button>

  <div class="email-compose-empty" *ngIf="!isEditMode && recipientCount === 0">
    {{ emptyMessage }}
  </div>
</div>
